/* eslint-disable max-classes-per-file */
import { Uuid } from '@ftr/contracts/type/shared'

export const ANNOTATION_TYPES_ACTION_SCOPE = '[Annotation Types]'
export class InitialiseAnnotationTypesCommand {
  static readonly type = `${ANNOTATION_TYPES_ACTION_SCOPE} Initialise Annotation Types`
  constructor(
    readonly courtSystemId: Uuid,
    readonly audioSegmentId?: Uuid,
  ) {}
}

export class FetchAnnotationTypesCommand {
  static readonly type = `${ANNOTATION_TYPES_ACTION_SCOPE} Fetch Annotation Types`
  constructor(
    readonly courtSystemId: Uuid,
    readonly audioSegmentId?: Uuid,
  ) {}
}
